import CryptoES from 'crypto-es';
import { put, call } from 'redux-saga/effects';

import { logIn } from '@api/auth';
import { API_STATUS_AUTH_CODE_SENT } from '@constants/general';
import { resendOtpFinished } from '@store/auth/auth.reducer';
import { toastError, toastSuccess } from '@store/notifications';

export const resendOtpSaga = function* ({ payload: { email, password } }) {
  try {
    if (!email || !password) return;

    const hashedPassword = CryptoES.SHA512(password).toString(CryptoES.enc.Hex);
    const response = yield call(logIn, email, hashedPassword, null, true);

    if (response?.status === API_STATUS_AUTH_CODE_SENT) {
      yield put(
        toastSuccess({
          message: {
            defaultMessage: 'OTP resent.',
            id: 'components.verify-otp-panel.resend.response.success',
          },
        })
      );
    }

    yield put(resendOtpFinished());
  } catch (error) {
    yield put(resendOtpFinished());
    const { nonFieldErrors, hasNonFieldError } = error.data || {};

    yield put(
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Resend OTP request failed.',
              id: 'components.verify-otp-panel.resend.response.failure',
            },
      })
    );
  }
};
